import ChangeScene from '../change-scenes/change-scene.entity';
import CharScene from '../char-scenes/char-scene.entity';
import Character from '../characters/character.entity';
import CmSceneNote from '../cm-scene-notes/cm-scene-note.entity';
import EpisodicActor from '../episodic-actors/episodic-actor.entity';
import EpisodicCharacter from '../episodic-characters/episodic-character.entity';
import EpisodicProp from '../episodic-props/episodic-prop.entity';
import HaChangeScene from '../ha-change-scenes/ha-change-scene.entity';
import HaSceneNote from '../ha-scene-notes/ha-scene-note.entity';
import MuChangeScene from '../mu-change-scenes/mu-change-scene.entity';
import MuSceneNote from '../mu-scene-notes/mu-scene-note.entity';
import PictureScene from '../picture-scenes/picture-scene.entity';
import PrSceneNote from '../pr-scene-notes/pr-scene-note.entity';
import PropSceneCharScene from '../prop-scene-char-scenes/prop-scene-char-scene.entity';
import PropScene from '../prop-scenes/prop-scene.entity';
import Scene from '../scenes/scene.entity';
import ScriptLocation from '../script-locations/script-location.entity';
import SetScene from '../set-scenes/set-scene.entity';
import Set from '../sets/set.entity';
import {
	SosCreateResponse,
	SosDeleteResponse,
	SosGetResponse,
	SosListResponse,
	SosUpdateResponse,
} from '../sos-response';
import { ProdBaseESDoc } from '../types';

export interface SceneESDoc extends ProdBaseESDoc {
	name: string;
	episode_num: string;
	script_location_name: string;
	script_location_id: number;
}

export interface SceneCreateResponse extends SosCreateResponse {
	created: {
		ChangeScene?: ChangeScene[];
		Character?: Character[];
		CharScene: CharScene[];
		CmSceneNote?: CmSceneNote[];
		HaChangeScene?: HaChangeScene[];
		HaSceneNote?: HaSceneNote[];
		MuChangeScene?: MuChangeScene[];
		MuSceneNote?: MuSceneNote[];
		PropSceneCharScene?: PropSceneCharScene[];
		PropScene?: PropScene[];
		PrSceneNote?: PrSceneNote[];
		Scene: Scene[];
		ScriptLocation?: ScriptLocation[];
		SetScene: SetScene[];
	};
	updated: {
		EpisodicCharacter: EpisodicCharacter[];
	};
}

export interface SceneGetResponse extends SosGetResponse {
	listed: {
		Character: Character[];
		CharScene: CharScene[];
		EpisodicActor: EpisodicActor[];
		EpisodicCharacter: EpisodicCharacter[];
		Scene: Scene[];
	};
	next: number;
	previous: number;
}

export interface SceneListResponse extends SosListResponse {
	listed: {
		Scene: Scene[];
		Set: Set[];
		SetScene: SetScene[];
		EpisodicCharacter: EpisodicCharacter[];
		CharScene: CharScene[];
		ScriptLocation: ScriptLocation[];
	};
}

export interface SceneUpdateResponse extends SosUpdateResponse {
	updated: {
		Scene: Scene[];
		EpisodicCharacter: EpisodicCharacter[];
	};
	created?: {
		CharScene?: CharScene[];
		SetScene?: SetScene[];
		ScriptLocation?: ScriptLocation[];
	};
	destroyed?: {
		CharScene?: CharScene[];
		SetScene?: SetScene[];
	};
}

export interface SceneDeleteResponse extends SosDeleteResponse {
	destroyed: {
		ChangeScene: ChangeScene[];
		CharScene: CharScene[];
		CmSceneNote: CmSceneNote[];
		HaChangeScene: HaChangeScene[];
		HaSceneNote: HaSceneNote[];
		MuChangeScene: MuChangeScene[];
		MuSceneNote: MuSceneNote[];
		PictureScene: PictureScene[];
		PropScene: PropScene[];
		PropSceneCharScene: PropSceneCharScene[];
		PrSceneNote: PrSceneNote[];
		Scene: Scene[];
		SetScene: SetScene[];
	};
}

export interface DeleteSceneCounts {
	sceneDepartmentNotes : number,
	cmChanges : number,
	haChanges : number,
	muChanges : number,
	props : number,
	pictures : number
}

export interface ScenePropListResponse extends SosListResponse {
	listed: {
		EpisodicProp: EpisodicProp[];
		PropScene: PropScene[];
		PropSceneCharScene: PropSceneCharScene[];
	};
}

export interface ScenesForEpisodicPropListResponse extends SosListResponse {
	listed: {
		PropScene: PropScene[];
		Scene: Scene[];
	};
}
